import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Tab, Tabs, Container } from "react-bootstrap";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import EditRep from "./Tabs/editRep";

export default function EditReport() {
  const { state } = useLocation();
  const { websiteName, setWebsiteName } = useWebsiteName();

  useEffect(() => {
    setTimeout(() => {
      setWebsiteName("ปิดงาน")
    }, 300);
  }, []);

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Perform Service Request Page" />
      </Helmet>

      <Container fluid className="p-0" id="tab_team">
        <Tabs
          justify
          defaultActiveKey={state?.name || "CloseJob"}
          className="mb-3"
        >
          <Tab eventKey="ServiceReq" title="ปฏิบัติงานตาม Service Request" disabled>
          </Tab>
          <Tab eventKey="ServiceReqDetail" title="ข้อมูลการปฏิบัติงานตาม Service Request" disabled>
          </Tab>
          <Tab eventKey="CloseJob" title="ปิดงาน">
            <EditRep />
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
